const $inject = ['locationsSearchService'];

const lbPoiSelectCtrl = function (locationsSearchService) {
  let vm = this;

  const MIN_SEARCH_TEXT_LENGTH = 2;
  const MAX_SEARCH_RESULTS = 10;
  const REFRESH_DELAY = 1000;
  const placeholdertext = vm.placeholdertext || 'Destination, airport, train station, landmark or hotel';

  vm.allowClear = true;
  vm.required = vm.required || false;
  vm.placeholder = vm.disablePlaceholder ? '' : placeholdertext;
  vm.iconClassName = vm.iconClassName || 'ico-marker';
  vm.options = [];
  vm.defaultOptions = vm.defaultOptions || [];
  vm.showLoader = vm.showLoader || false;
  vm.refreshDelay = REFRESH_DELAY;

  vm.refreshOptions = refreshOptions;
  vm.onRemove = onRemove;

  vm.defaultOptions = _.orderBy(vm.defaultOptions, 'Title');

  vm.options = _.clone(vm.defaultOptions);

  function refreshOptions(search) {
    if (search.length <= MIN_SEARCH_TEXT_LENGTH) {
      return vm.defaultOptions;
    }

    vm.showLoader = true;

    return locationsSearchService
      .get({
        maxRows: MAX_SEARCH_RESULTS,
        term: search,
        searchTypes: vm.searchtypes,
      })

      .then((result) => {
        vm.options = result;
      })

      .finally(() => {
        vm.showLoader = false;
      });
  }

  function onRemove() {
    vm.options = _.clone(vm.defaultOptions);
  }
};

lbPoiSelectCtrl.$inject = $inject;

export default lbPoiSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbPoiSelect/lbPoiSelectCtrl.js